import apiClient from './client';

export async function discoverHintApi(hintId) {
  const response = await apiClient.post('/api/hints/discover', { hint_id: hintId });
  return response.data;
}
